import { render } from "./index.vue?vue&type=template&id=ac075648&scoped=true&bindings={}"
import script from "./Suspense-info.js?vue&type=script&lang=js"
export * from "./Suspense-info.js?vue&type=script&lang=js"

import "./Suspense-info.scss?vue&type=style&index=0&id=ac075648&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-ac075648"

export default script